import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "tab", "panel" ]

  connect() {
    this.showTab(0)
  }

  switch(event) {
    event.preventDefault()
    const clickedTab = event.currentTarget
    const idx = this.tabTargets.indexOf(clickedTab)
    this.showTab(idx)
  }

  showTab(idx) {
    this.tabTargets.forEach(tab  => {
      tab.classList.remove("border-blue-600", "text-blue-600", "font-semibold")
      tab.classList.add("text-gray-600")
    })
    this.panelTargets.forEach(panel => {
      panel.classList.add("hidden")
    })

    const activeTab   = this.tabTargets[idx]
    const activePanel = this.panelTargets[idx]
    activeTab.classList.remove("text-gray-600")
    activeTab.classList.add("border-blue-600", "text-blue-600", "font-semibold")

    activePanel.classList.remove("hidden")
  }
}
